import { render } from "./RequestInformation.vue?vue&type=template&id=7c1c6baa"
import script from "./RequestInformation.vue?vue&type=script&lang=js"
export * from "./RequestInformation.vue?vue&type=script&lang=js"
script.render = render

export default script